import colorStyles from '../../../../colors/colors.module.css';
import backgroundStyles from '../../../../colors/backgrounds.module.css';
import borderColorStyles from '../../../../colors/borderColors.module.css';
export function getColorProps(color) {
  var className = colorStyles["color_".concat(color)];
  if (className) {
    return {
      className: className
    };
  }
  return {
    style: {
      color: color
    }
  };
}
export function getBackgroundProps(background) {
  var className = backgroundStyles["background_".concat(background)];
  if (className) {
    return {
      className: className
    };
  }
  return {
    style: {
      background: background
    }
  };
}
export function getBorderProps(_ref) {
  var borderColor = _ref.borderColor,
    borderStyle = _ref.borderStyle,
    borderWidth = _ref.borderWidth;
  var style = {};
  var borderColorClassName = borderColorStyles["borderColor_".concat(borderColor)];
  if (!borderColorClassName) {
    style.borderColor = borderColor;
  }
  if (borderStyle) {
    style.borderStyle = borderStyle;
  }
  if (borderWidth) {
    style.borderWidth = "".concat(borderWidth, "px");
  }
  return {
    style: style,
    className: borderColorClassName
  };
}